export default __webpack_public_path__ + "static/media/demoBackgroundA.abd4697d.jpg";